/* eslint-disable import/prefer-default-export */
export const Modal = function Modal() {
  this.modals = {};

  /**
   * Creat new modal and return reference to new modal object
   * @param {String} selector new Modal selector
   * @param {String} className custom class attribiute for new modal node
   * @param {String} activator selector for
   */
  this.createModal = ({
    selector,
    className,
    activator,
    isActive,
  }) => {
    const content = document.querySelector(selector);
    const additionalClass = className || `modal_${Object.keys(this.modals).length}`;

    if (!content) {
      return;
    }

    const newModal = document.createElement('section');
    newModal.classList.add('modal');
    newModal.classList.add(additionalClass);


    newModal.innerHTML = `
      <button type="button" class="--close"><i class="icon-remove"></i></button>
      <div class="--wrapper">${content.outerHTML}</div>
    `;
    const additionalSelector = `.${additionalClass}`;
    newModal.querySelector('.--close').addEventListener('click', () => this.closeModal(additionalSelector));

    // content.parentNode.insertBefore(newModal, content);
    // content.remove();
    content.replaceWith(newModal);

    this.setModal({ selector: additionalSelector, activeButton: activator, isActive });
  };
  this.setModal = ({ selector, activeButton, isActive }) => {
    const button = document.querySelector(activeButton);
    const content = document.querySelector(selector);

    if (!content) {
      throw Error('Selector does not match any dom elements');
    }

    this.modals[selector] = {
      content,
      selector,
      isActive: isActive || false,
      buttonActivator: button,
    };
    if (button) {
      this.modals[selector].buttonActivator.addEventListener('click', () => this.openModal(selector));
    }
    if (content) {
      this.modals[selector].content.classList.add('modal');
    }
    if (isActive) {
      this.openModal(selector);
    }
  };
  this.openModal = (selector) => {
    if (!this.modals[selector]) {
      throw Error('Selector does not match any dom elements');
    }
    setTimeout(() => {
      this.modals[selector].content.classList.add('--open-modal');
      this.modals[selector].isActive = true;
      const cover = document.querySelector('.modal__cover');
      if (!cover) {
        document.body.insertAdjacentHTML('beforeend', '<div class="modal__cover --active"></div>');
      }
    }, 100);
  };
  this.closeModal = (selector) => {
    if (!this.modals[selector]) {
      throw Error('Selector does not match any dom elements');
    }
    this.modals[selector].content.classList.remove('--open-modal');
    this.modals[selector].isActive = false;
    const cover = document.querySelector('.modal__cover');
    if (cover) {
      cover.classList.remove('--active');
      setTimeout(() => cover.remove(), 250);
    }
  };
};
